var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMylogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1719,
    height: 1719,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-566 -378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M711.5 778.723C711.5 709.564 767.565 653.5 836.724 653.5L2015.28 653.5C2084.44 653.5 2140.5 709.564 2140.5 778.723L2140.5 1697.28C2140.5 1766.44 2084.44 1822.5 2015.28 1822.5L836.724 1822.5C767.565 1822.5 711.5 1766.44 711.5 1697.28Z",
    stroke: "#FFFFFF",
    strokeWidth: 41.25,
    strokeMiterlimit: 8,
    fill: "#252525",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.01 1602.02 2013.88 1602.02 2013.88 1617.49 1798.01 1617.49ZM1267 1259.58 1173.5 1446.89 1360.6 1446.89ZM1260.25 1243.23 1273.75 1243.23 1378.46 1452.83 1378.46 1562.49 1362.7 1562.49 1362.7 1462.22 1171.4 1462.22 1171.4 1562.49 1155.64 1562.49 1155.64 1452.65ZM845.874 1240.65 1007.91 1402.79 845.874 1564.85 836.478 1555.53 989.618 1402.79 836.478 1250.04ZM1531.05 1239.79 1693.88 1239.79 1693.88 1255.13 1537.36 1255.13 1490.4 1302.3 1490.4 1503.47 1537.28 1550.37 1681.7 1550.37 1681.7 1410.63 1633.25 1410.63 1633.25 1395.09 1697.46 1395.09 1697.46 1565.71 1530.98 1565.71 1474.64 1509.57 1474.64 1296.22Z",
    stroke: "#00FF00",
    strokeWidth: 9,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#00FF00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 0,
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontSize: 377.695,
    x: 836.478,
    y: 1570.28
  }, "&gt;AG_"), /*#__PURE__*/React.createElement("path", {
    d: "M711 908 2140.13 908",
    stroke: "#FFFFFF",
    strokeWidth: 32.0833,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1949.5 781C1949.5 763.051 1963.6 748.5 1981 748.5 1998.4 748.5 2012.5 763.051 2012.5 781 2012.5 798.949 1998.4 813.5 1981 813.5 1963.6 813.5 1949.5 798.949 1949.5 781Z",
    stroke: "#FFFFFF",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.5 781C1834.5 763.051 1848.83 748.5 1866.5 748.5 1884.17 748.5 1898.5 763.051 1898.5 781 1898.5 798.949 1884.17 813.5 1866.5 813.5 1848.83 813.5 1834.5 798.949 1834.5 781Z",
    stroke: "#FFFFFF",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1719.5 781C1719.5 763.051 1733.83 748.5 1751.5 748.5 1769.17 748.5 1783.5 763.051 1783.5 781 1783.5 798.949 1769.17 813.5 1751.5 813.5 1733.83 813.5 1719.5 798.949 1719.5 781Z",
    stroke: "#FFFFFF",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylogo);
export default __webpack_public_path__ + "static/media/mylogo.d051de173dd99e56435c85c452f559a7.svg";
export { ForwardRef as ReactComponent };